import { jsx } from 'react/jsx-runtime';
import * as Headlessui from '@headlessui/react';
import classNames from 'classnames';
import { PopoverDropdown } from './Popover.Dropdown/Popover.Dropdown.es.js';
import { PopoverIconButton } from './Popover.IconButton/Popover.IconButton.es.js';
import { PopoverPanel } from './Popover.Panel/Popover.Panel.es.js';

const Popover = ({ className, children, alignment = 'start' })=>{
    // Find popover panel
    const popoverPanels = children.filter((c)=>c.type === PopoverPanel);
    // Make sure popoverComponents exist or throw
    if (popoverPanels.length !== 1) {
        throw new Error('You must have one `Popover.Panel` inside the Popover');
    }
    return jsx(Headlessui.Popover, {
        className: classNames('cb-popover', `align-${alignment}`, className),
        "data-testid": "popover",
        children: children
    });
};
Popover.displayName = 'Popover';
Popover.Dropdown = PopoverDropdown;
Popover.IconButton = PopoverIconButton;
Popover.Panel = PopoverPanel;

export { Popover, Popover as default };
//# sourceMappingURL=Popover.es.js.map
